import React from "react";

import { isArray, isEmpty, isNil } from "lodash";
import AdditionalActionsItem from "./AdditionalActionsItem";

export default function AdditionalActionsDialog(props) {
  const { additionalActions, ...other } = props;

  if (
    isNil(additionalActions) ||
    isEmpty(additionalActions) ||
    !isArray(additionalActions)
  ) {
    return null;
  }

  return (
    <>
      {additionalActions.map((aa, index) => {
        return (
          <AdditionalActionsItem key={index} aditionalAction={aa} {...other} />
        );
      })}
    </>
  );
}
